import script from "./ToastHost.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastHost.vue?vue&type=script&setup=true&lang=js"

import "./ToastHost.vue?vue&type=style&index=0&id=8af1e530&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8af1e530"]])

export default __exports__